import StandardShipping from "./ShippingDate";
import { styleDateString, findType } from "./helpers";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import React from "react";
import when from "recompose/branch";
import renderComponent from "recompose/renderComponent";
import Loading from "../../Loading";
import { replaceTextWithValues } from "src/common/utils/text-replace";
import { withModel } from "../../../data-providers/model";

const enhance = compose(
  when(
    (props) => props.isLoading,
    renderComponent(
      () => <Loading dark relative small />,
      (c) => c
    )
  ),
  withModel,
  withProps((props) => {
    let shippingDates = [];
    let dates = "";

    if (props.shippingDates.length === 0) {
      shippingDates = props.model.eagleModel.shippingEstimates;
    } else {
      shippingDates = props.shippingDates;
    }

    if (shippingDates.length > 0) {
      let dateObj = {};
      if (shippingDates.length === 1) {
        dateObj = shippingDates[0];
      } else if (props.isTracked) {
        dateObj = findType(shippingDates, "tracked");
      } else {
        dateObj = findType(shippingDates, "standard");
      }
      dates = styleDateString(dateObj, props.countryModel);
    }

    return {
      shippingDate: props.description
        ? replaceTextWithValues(props.description, { express: dates })
        : dates,
    };
  })
);

export default enhance(StandardShipping);
